// extracted by mini-css-extract-plugin
export default {"errorPage_container":"styles_errorPage_container__W22C1","errorPage_content":"styles_errorPage_content__AuGhU","errorPage_errorIcon":"styles_errorPage_errorIcon__kFJd2"};